import { observer } from 'mobx-react';
import React from 'react';

import { Paginated } from '../../../../adl-gen/common';
import { WithDbId } from '../../../../adl-gen/common/db';
import { Question, WorkRole } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { RepositoryEntrySet } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { Loader, MaybeLoading } from '../../../../loader/loader';
import { Route } from '../../../../routing/app-routes';
import { PageLayoutFn } from '../../../../ui/common/page-layout/page-layout';
import { QuizAdminStore } from '../../../stores';
import { FormMode } from '../../common/form';
import { QuizAdminForm } from '../../components/forms/quiz-admin-form/quiz-admin-form';

interface QuizAdminScreenProps {
  pageLayout: PageLayoutFn;
  navigateTo(route: Route): void;

  workrole: MaybeLoading<WithDbId<WorkRole>>;
  repository: MaybeLoading<RepositoryEntrySet>;
  nonSkillQuestions: MaybeLoading<Paginated<WithDbId<Question>>>;
  store: QuizAdminStore;

  mode?: FormMode;
  onCancel?(): void;
}

@observer
export class QuizAdminScreen extends React.Component<QuizAdminScreenProps> {
  onCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  QuizAdminFormLoader = () => <Loader state={this.props.workrole} LoadedComponent={this.renderQuizAdminForm} />;

  renderQuizAdminForm = observer((role: WithDbId<WorkRole>) => {
    const { nonSkillQuestions, repository, store } = this.props;
    if (nonSkillQuestions.kind === 'value' && repository.kind === 'value') {
      return (
        <QuizAdminForm
          workrole={role}
          repository={repository.value}
          nonSkillQuestions={nonSkillQuestions.value.items}
          store={store}
          onCancel={this.onCancel}
        />
      );
    } else {
      return null;
    }
  });
  render() {
    /// Title is required to ensure subnav gets rendered
    return (
      /// TODO: Client Admin - specify client
      <this.props.pageLayout title={'Administration - Assessment'}>
        <this.QuizAdminFormLoader />
      </this.props.pageLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/screens/quiz-admin-screen/quiz-admin-screen.tsx